import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll } from "./rhdetailAPI";

const initialState = {
  value: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
};

export const fetchAll = createAsyncThunk("rhdetail/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const rhdetailSlice = createSlice({
  name: "rhdetail",
  initialState,
  reducers: { resetData: (state) => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      });
  },
});

export const { resetData } = rhdetailSlice.actions;

export const selectData = (state) => state.rhdetail.value;
export const selectLoading = (state) => state.rhdetail.loading;
export const selectError = (state) => state.rhdetail.error;
export const selectPageNo = (state) => state.rhdetail.pageNo;
export const selectPageSize = (state) => state.rhdetail.pageSize;
export const selectTotalRecord = (state) => state.rhdetail.totalRecord;

export default rhdetailSlice.reducer;
